import { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  Box,
  Avatar,
  ListItemAvatar,
  Stack,
  Container,
} from "@mui/material";
import { Menu } from "@mui/icons-material";
import { Link } from "react-router-dom";
import headerOptions from "../utils/headerOptions";
import { useAuth } from "../hooks/useAuth";
import Logo from "../images/LOGO DEFINITIVO POLLOS TEOOO.png";
import InfoIcon from "@mui/icons-material/Info";

function GlobalHeader() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { loggedAuth } = useAuth();
  const [options, setOptions] = useState(
    loggedAuth ? headerOptions.logged : headerOptions.default
  );

  useEffect(() => {
    setOptions(!!loggedAuth ? headerOptions.logged : headerOptions.default);
  }, [loggedAuth]);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsDrawerOpen(open);
  };
  return (
    <>
      <AppBar
        id="GlobalHeader"
        position="static"
        sx={{
          backgroundColor: "background.paper",
          borderBottom: "2.1px solid #e0e0e0",
        }}
      >
        <Container
          sx={{
            py: 0.5, // Reducido de py: 1 a py: 0.5
          }}
        >
          <Toolbar sx={{ minHeight: "auto", py: 0.5 }}>
            {" "}
            {/* Toolbar más compacto */}
            {!!loggedAuth && (
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{
                  color: "black",
                  display: {
                    xs: "inherit",
                    lg: "none",
                  },
                }}
                onClick={toggleDrawer(true)}
              >
                <Menu />
              </IconButton>
            )}
            <Box
              sx={{
                flexGrow: 1,
                py: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "flex-end", lg: "flex-start" },
              }}
              component={Link}
              to="/"
            >
              <img
                src={Logo}
                alt="Pollos Teo Logo"
                style={{
                  width: "auto",
                  height: "50px",
                  borderRadius: 0,
                  margin: "0px",
                  transform: "scale(2.7)",
                  marginRight: "25px",
                }}
              />
            </Box>
            <Stack
              direction="row"
              sx={{
                display: {
                  xs: "none",
                  lg: "inherit",
                },
              }}
              spacing={3}
            >
              {options.map((row, key) => {
                if (row.route !== "/logout") return undefined;

                return (
                  <Box
                    key={key}
                    component={Link}
                    to={row.route}
                    display="flex"
                    alignItems="center"
                    gap="3px"
                    sx={{
                      color: "black",
                      cursor:
                        window.location.pathname === row.route
                          ? "default"
                          : "pointer",
                      borderBottom: "2px solid",
                      transition: "border-color 0.2s ease-in-out",
                      pb: 1,
                      borderColor:
                        window.location.pathname === row.route
                          ? "#fff"
                          : "#fcd528",
                      ":hover": {
                        borderColor: "#ecb806",
                      },
                    }}
                  >
                    <row.icon />
                    <Typography color="black">{row.title}</Typography>
                  </Box>
                );
              })}
              <Box
                component={Link}
                to="/about"
                display="flex"
                alignItems="center"
                gap="3px"
                sx={{
                  color: "black",
                  cursor:
                    window.location.pathname === "/about"
                      ? "default"
                      : "pointer",
                  borderBottom: "2px solid",
                  transition: "border-color 0.2s ease-in-out",
                  pb: 1,
                  borderColor:
                    window.location.pathname === "/about" ? "#fff" : "#fcd528",
                  ":hover": {
                    borderColor: "#ecb806",
                  },
                }}
              >
                <InfoIcon />
                <Typography color="black">Acerca del proyecto</Typography>
              </Box>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
      <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <div
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <Box bgcolor="white" px={2} height="100vh" overflow="hidden">
            <List sx={{ height: "100%", p: 0, pt: 2 }}>
              <Stack justifyContent="space-between" sx={{ height: "100%" }}>
                <Box
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  <ListItem sx={{ my: 1 }}>
                    <ListItemAvatar>
                      <Avatar
                        src={Logo}
                        sx={{
                          width: "180px",
                          height: "auto",
                          borderRadius: 0,
                        }}
                      />
                    </ListItemAvatar>
                  </ListItem>
                  {options.map((item, i) => (
                    <Link key={i} to={item.route}>
                      <ListItem>
                        <Stack
                          spacing={1}
                          direction="row"
                          sx={{
                            borderBottom: "3px solid",
                            borderColor:
                              window.location.pathname === item.route
                                ? "primary.main"
                                : "white",
                            width: "100%",
                            py: 1,
                            svg: {
                              color: "#000!important",
                            },
                          }}
                        >
                          <item.icon />
                          <Typography color="black">{item.title}</Typography>
                        </Stack>
                      </ListItem>
                    </Link>
                  ))}
                  <Link to="/about">
                    <ListItem>
                      <Stack
                        spacing={1}
                        direction="row"
                        sx={{
                          borderBottom: "3px solid",
                          borderColor:
                            window.location.pathname === "/about"
                              ? "primary.main"
                              : "white",
                          width: "100%",
                          py: 1,
                          svg: {
                            color: "#000!important",
                          },
                        }}
                      >
                        <InfoIcon />
                        <Typography color="black">
                          Acerca del proyecto
                        </Typography>
                      </Stack>
                    </ListItem>
                  </Link>
                </Box>
              </Stack>
            </List>
          </Box>
        </div>
      </Drawer>
    </>
  );
}

export default GlobalHeader;
